import { Create, NumberInput, SimpleForm, TextInput } from 'react-admin';
import { CustomTitle } from '../../components/CustomTitle';

const initialValues = {
  title: '',
};
export const LocationCreate = (props: unknown) => (
  <Create {...props} title={<CustomTitle />}>
    <SimpleForm redirect={false} defaultValues={initialValues}>
      <TextInput source="title" />
      <TextInput source="direction" />
      <NumberInput source="order" />
    </SimpleForm>
  </Create>
);
